import { z } from 'zod';
export const AlertStatusFilter = z.enum(['all', 'open', 'resolved']);
export type AlertStatusFilter = z.infer<typeof AlertStatusFilter>;
export const AlertSearchSchema = z.object({
  status: AlertStatusFilter.default('all'),
  freeText: z.string().default(''),
  pageSize: z.number().default(100),
  pageIndex: z.number().default(0)
});
export type AlertSearchParams = z.infer<typeof AlertSearchSchema>;